// Same key and shape as axios-jwt used, so existing sessions survive the switch.
const STORAGE_KEY = `auth-tokens-${import.meta.env.MODE}`;

interface AuthTokens {
  accessToken: string;
  refreshToken: string;
}

const readTokens = (): AuthTokens | undefined => {
  const raw = localStorage.getItem(STORAGE_KEY);
  return raw ? (JSON.parse(raw) as AuthTokens) : undefined;
};

export const setAuthTokens = (tokens: AuthTokens) =>
  localStorage.setItem(STORAGE_KEY, JSON.stringify(tokens));

export const setAccessToken = (accessToken: string) =>
  setAuthTokens({ ...readTokens()!, accessToken });

export const getAccessToken = () => readTokens()?.accessToken;
export const getRefreshToken = () => readTokens()?.refreshToken;
export const clearAuthTokens = () => localStorage.removeItem(STORAGE_KEY);
export const isLoggedIn = () => !!getRefreshToken();

/** A JWT's claims; tokens are ASCII, so plain base64url decoding suffices. */
export function jwtClaims(token: string): { exp: number; user_id?: number } {
  const payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
  return JSON.parse(atob(payload));
}
